<template>
  <div class="promo-table__type">
    <img
      v-if="typeConfig[type] && typeConfig[type].icon"
      :class="`type__icon--${type}`"
      :src="require(`@/assets/images/${typeConfig[type].icon}-type-icon.svg`)"
      alt="t"
    >
  </div>
</template>

<script>
export default {
  name: "PromotionTypeIcon",

  props: {
    type: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      typeConfig: [
        {
          name: "",
          icon: "",
        },
        {
          name: this.$t('campaign.communications.marketingCalendar.byEvent'),
          icon: "trigger",
        },
        {
          name: this.$t('campaign.communications.marketingCalendar.scheduled'),
          icon: "schedule",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.promo-table__type {
  .type__icon {
    &--1 {
      margin-left: -5px;
      margin-bottom: -3px;
      margin-right: -2px;
    }
    &--2 {
      // margin-left: 2px;
      margin-right: 2px;
      margin-bottom: -5px;
    }
  }
}
</style>
